import {getValueFieldSlug} from '@packages/systems/dynamo/utils/ParamFieldPathUtils';
import {PAST} from '@packages/systems/dynamo/constants';

import {getAvailableOperatorsByFieldType} from '@packages/systems/dynamo/utils/ParamPanelUtils';
import {
  OPERATOR_EQ,
  OPERATOR_NE,
  OPERATOR_EXISTS,
  OPERATOR_NOT_EXISTS,
  isComparisonOperator,
} from '@packages/systems/dynamo/utils/DynQueryUtils';

import {getAvailableDateUnitOptions} from './utils';

import type {ParamPanelState, ParamPanelUIProps} from './types';

export function getOperatorOptions(
  fieldPath: string,
  fieldType: string,
  fieldInnerType: string
) {
  if (fieldType === 'Id') {
    return [
      {name: 'is', id: OPERATOR_EQ},
      {name: 'is not', id: OPERATOR_NE},
    ];
  } else if (
    getValueFieldSlug(fieldPath) === 'name' ||
    getValueFieldSlug(fieldPath) === 'ec-product-type'
  ) {
    return [
      {name: 'Equals', id: OPERATOR_EQ},
      {name: 'Does Not Equal', id: OPERATOR_NE},
    ];
  } else if (fieldInnerType === 'ImageRef') {
    return [
      {name: 'Is Set', id: OPERATOR_EXISTS},
      {name: 'Is Not Set', id: OPERATOR_NOT_EXISTS},
    ];
  } else {
    return getAvailableOperatorsByFieldType(fieldType);
  }
}

export function __DEPRECATED__getInitialValues({
  fieldType,
  availableItemRefOptions,
  availableOptionOptions,
}: {
  fieldType: string;
  availableItemRefOptions: ParamPanelUIProps['availableItemRefOptions'];
  availableOptionOptions: ParamPanelUIProps['availableOptionOptions'];
}) {
  switch (fieldType) {
    case 'Date': {
      const availableDateUnitOptions = getAvailableDateUnitOptions();
      return {
        value: 1,
        value2: availableDateUnitOptions[0],
        value3: PAST,
      };
    }
    case 'Option': {
      return {
        value:
          availableOptionOptions.length > 0
            ? // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
              availableOptionOptions[0].id
            : null,
        value2: null,
        value3: null,
      };
    }
    case 'ItemRef':
    case 'ItemRefSet': {
      return {
        value:
          availableItemRefOptions.length > 0
            ? // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
              availableItemRefOptions[0].value
            : null,
        value2: null,
        value3: null,
      };
    }
    default: {
      return {
        value: null,
        value2: null,
        value3: null,
      };
    }
  }
}

export function getInitialValues({
  fieldType,
  availableItemRefOptions,
  availableOptionOptions,
}: {
  fieldType: string;
  availableItemRefOptions: ParamPanelUIProps['availableItemRefOptions'];
  availableOptionOptions: ParamPanelUIProps['availableOptionOptions'];
}) {
  switch (fieldType) {
    case 'Date': {
      const availableDateUnitOptions = getAvailableDateUnitOptions();
      return {
        value: 1,
        value2: availableDateUnitOptions[0],
        value3: PAST,
      };
    }
    case 'Option': {
      return {
        value: availableOptionOptions[0]?.id ?? null,
        value2: null,
        value3: null,
      };
    }
    case 'ItemRef':
    case 'ItemRefSet': {
      return {
        value: availableItemRefOptions[0]?.value ?? null,
        value2: null,
        value3: null,
      };
    }
    case 'CommercePrice':
    case 'Number': {
      return {
        value: 0,
        value2: null,
        value3: null,
      };
    }
    default: {
      return {
        value: '',
        value2: null,
        value3: null,
      };
    }
  }
}

export function operatorChangeHandler({
  handleChange,
  operator: prevOperator,
  fieldType,
  availableItemRefOptions,
  availableOptionOptions,
}: {
  handleChange: any;
  operator: ParamPanelState['operator'];
  fieldType: string;
  availableItemRefOptions: ParamPanelUIProps['availableItemRefOptions'];
  availableOptionOptions: ParamPanelUIProps['availableOptionOptions'];
}) {
  return function onOperatorChange(operator: ParamPanelState['operator']) {
    if (isComparisonOperator(operator) && isComparisonOperator(prevOperator)) {
      handleChange({operator});
    } else {
      // If we are not still comparing, we need to reinitialize the values
      handleChange({
        operator,
        ...__DEPRECATED__getInitialValues({
          fieldType,
          availableItemRefOptions,
          availableOptionOptions,
        }),
      });
    }
  };
}
